

<mat-card class="full-stretch flex-column checklist-card padding-none responsive-card">

    <mat-card-header #cardHeader class="card-header border-primary-bottom padding-standard">
        <mat-card-title class="mat-headline-4" *ngIf="title" class="flex-row">{{title | translate}} </mat-card-title>
        <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>
    </mat-card-header>
    
    <mat-card-content fixedScroll [otherElements]="[header,footer]" class="padding-standard" >

        <mat-checkbox [disabled]="allSelectedObs | async" [checked]="allSelectedObs | async" (change)="checkAll()">
            {{'ss-general.select-all' | translate}}
        </mat-checkbox>
        
        <hr/>
        
        <div *ngFor="let element of selectedDataObs | async;trackBy:trackByIdx" >
            
            <mat-checkbox 
                    color="primary" 
                    [checked]="element.selected" 
                    (change)="setChecked(element,$event)"
            >
                {{element[displayExpr]}}
            </mat-checkbox>

        </div>
    </mat-card-content>
    
    <mat-card-footer #footer class="flex-row padding-standard responsive-actions">
        <button (click)="close()"  color="warn"   class="flex-1"    mat-raised-button  > {{'ss-general.cancel' | translate}}</button>
        <button (click)="submit()" color="primary" class="flex-1" mat-raised-button >{{(defaultBtnText || 'ss-general.yes') | translate}}</button>
    </mat-card-footer>
</mat-card>